<template>
  <div class="transfer-media-container">
    <UContainer :active="active"></UContainer>
    <DContainer :active="active"></DContainer>
  </div>
</template>

<script>
  import UContainer from './UContainer.vue'
  import DContainer from './DContainer.vue'

  export default {
    name: 'transfer-media-container',
    components: {DContainer, UContainer},
    props: {
      active: Boolean
    },
    data () {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .transfer-media-container {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 450;
    background-color: white;
    margin: 2rem;

    @media only screen and (max-width: 599px) {
      margin: 0;
      left: 0;
      max-width: 100vw;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/plugins/uploader/components/TransferMediaContainer.vue